import React, { useEffect, useState } from 'react';
import Form from 'react-bootstrap/Form';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import { default as TooltipButton } from 'react-bootstrap/Button';
import { useFormContext } from 'react-hook-form';
import useValidation from 'conversie-flow-bundle/assets/js/components/flow/hooks/useValidation';

/* Common */
import { Button, Modal, Icon } from '~/components/common';

/* Icons */
import InfoIcon from '~/../symbols/info-circle.svg';
import CheckIcon from '~/../symbols/check.svg';

/* Utilities */
import { trans } from '~/utilities';

export default function ConversionFieldChoiceSubscription(props) {
    const { customControlClassName = '', field, inputType, path, id } = props;
    const { required, disabled, value } = field;
    const [currentSubscription, setSubscription] = useState();
    const [chosenSubscription, setChosenSubscription]= useState();
    const [open, setOpen] = useState(false);

    const form = useFormContext();
    const {
        setValue = () => { },
    } = form || {};

    const { error } = useValidation({ path, ...field, ...form });

    useEffect(() => {
        setValue(path, value);

        let selectedChoice = null;

        field.choices.forEach((choice) => {
            if (choice.selected) {
                selectedChoice = choice;
            }
        });

        if (selectedChoice) {
            clearSubscriptions();
            setSubscription(selectedChoice);
            setChosenSubscription(selectedChoice);
            storeSubscription(selectedChoice);
        } else {
            clearSubscriptions();
            setSubscription(field.choices[0]);
            setChosenSubscription(field.choices[0]);
        }
    }, [value]);

    const storeSubscription = (subscription) => {
        if (field.view === 'vdp-subscription') {
            sessionStorage.removeItem('subscription');
            if (subscription.price !== -1) sessionStorage.setItem('subscription', JSON.stringify(subscription));
        }
        if (field.name === 'delivery-packages') {
            sessionStorage.removeItem('delivery');
            if (subscription.price !== -1) sessionStorage.setItem('delivery', JSON.stringify(subscription));
        }
    }

    const clearSubscriptions = () => {
        if (field.view === 'vdp-subscription') sessionStorage.removeItem('subscription');
        if (field.name === 'delivery-packages') sessionStorage.removeItem('delivery');
    }

    return (
        <div className="row gutters-0 mb-0">
            <div className="col-12">
                <Form.Check
                    className={`custom-${inputType} ${customControlClassName} pb-1 ${error ? 'is-error' : ''}`}
                    type={inputType}
                    id={`${id}`}
                >
                        <Form.Check.Input
                            type={inputType}
                            className="custom-control-input"
                            name={field.name}
                            {...{
                                required,
                                disabled,
                            }}
                            checked={chosenSubscription && chosenSubscription.key !== 'false' && chosenSubscription.key !== 'Basispakket'}
                            onChange={() => {}}
                            onClick={(e) => {
                                e.preventDefault();
                                setOpen(true);
                            }}
                        />
                        <Form.Check.Label className="custom-control-label custom-control-label--checkbox">
                            <div className="custom-control-label__title">
                                <span dangerouslySetInnerHTML={{ __html: chosenSubscription?.label}} />
                                <div className="d-flex align-items-center">
                                    {(chosenSubscription && chosenSubscription.key !== 'false' && chosenSubscription.key !== 'Basispakket') && (
                                        <p className="mb-0 mr-2 choice__change">{trans('app.flow.edit_label')}</p>
                                    )}
                                    {chosenSubscription?.['pay-off'] && (
                                        <p className="mb-0 mr-1 choice__price">{chosenSubscription?.['pay-off']}</p>
                                    )}
                                    {(chosenSubscription?.tooltip && chosenSubscription.tooltip !== '') && (
                                        <OverlayTrigger
                                            placement="bottom"
                                            overlay={
                                                <Tooltip id={`tooltip-${id}`}>
                                                    {chosenSubscription.tooltip}
                                                </Tooltip>
                                            }
                                        >
                                            <TooltipButton
                                                variant="none"
                                                className="p-0 btn--tooltip"
                                            >
                                                <Icon
                                                    theme="base"
                                                    size={14}
                                                    url={InfoIcon?.url}
                                                    className={`icon--tooltip`}
                                                />
                                            </TooltipButton>
                                        </OverlayTrigger>
                                    )}
                                </div>
                            </div>
                        </Form.Check.Label>
                </Form.Check>
                {error && (
                    <Form.Control.Feedback type="invalid">
                        {error}
                    </Form.Control.Feedback>
                )}
            </div>
            <Modal
                className="modal--subscription"
                open={open}
                handleClose={() => setOpen(false)}
                backText={trans('app.flow.modal_back')}
                modalTitle={''}
                modalBody={(
                    <div>
                        <p className="modal__title">{props?.component?.metadata?.modal_title}</p>
                        <p className="modal__subtitle">{props?.component?.metadata?.modal_subtitle}</p>
                        <p className="modal__description">{props?.component?.metadata?.modal_description}</p>
                        <div className="modal__choices">
                            <div className="row gutters-2">
                                {field.choices.map((choice, index) => (
                                    <div key={index} className="col-12 col-lg">
                                        <div className="custom-control custom-radio">
                                            <input
                                                id={`${field.name}-${choice.key}`}
                                                name={field.name}
                                                className="custom-control-input"
                                                type="radio"
                                                defaultChecked={chosenSubscription ? (choice === chosenSubscription) : (index === 0)}
                                                onChange={() => {
                                                    setSubscription(choice);
                                                }}
                                            />
                                            <label
                                                htmlFor={`${field.name}-${choice.key}`}
                                                className="custom-control-label"
                                            >
                                                {choice?.most_chosen && (
                                                    <span className="custom-control-label__badge">
                                                        {trans('app.flow.most_chosen')}
                                                    </span>
                                                )}
                                                <p className="choice__label">{choice.label}</p>
                                                {choice?.['pay-off'] && (
                                                    <p className="mb-2 mb-xl-3">{choice?.['pay-off']}</p>
                                                )}
                                                {(field.name !== 'delivery-packages') ? (
                                                    <p className="mb-0">{choice.tooltip}</p>
                                                ) : (
                                                    <ul className="list">
                                                        {choice.tooltip.split(',').map((item, index) => (
                                                            <li key={index} className="list__item">
                                                                <Icon
                                                                    theme="success"
                                                                    size={14}
                                                                    className={`flex-shrink-0 mr-2`}
                                                                    url={CheckIcon?.url}
                                                                />
                                                                <p className="mb-0" dangerouslySetInnerHTML={{ __html: item}} />
                                                            </li>
                                                        ))}
                                                    </ul>
                                                )}
                                            </label>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                        <div className="d-block d-lg-flex align-items-center justify-content-between">
                            <p className="modal__vat">{props?.component?.metadata?.modal_btw_text}</p>
                            <div className="modal__sticky">
                                <Button
                                    className="btn--submit"
                                    theme="success"
                                    title={props?.component?.metadata?.modal_button}
                                    onClick={(e) => {
                                        e.preventDefault();
                                        setChosenSubscription(currentSubscription);
                                        storeSubscription(currentSubscription);
                                        setOpen(false);
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                )}
            />
        </div>
    );
}
